import { useCallback, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  PATH_SETTINGS_PAYMENT_METHODS,
  PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYMENT_METHOD
} from "..";
import { Layout } from "../../../../../shared/components/Layout";
import { FlowAddPaymentMethod } from "../../../components/payment/FlowAddPaymentMethod";

export const RouteAddPaymentMethod: React.FC = () => {
  const history = useHistory();
  const location = useLocation<{ backPath?: string }>();

  const [backPath] = useState(
    location.state?.backPath || PATH_SETTINGS_PAYMENT_METHODS
  );

  const onBack = useCallback(() => {
    history.push(backPath);
  }, [backPath, history]);

  return (
    <Layout
      title="Add payment method"
      onClose={onBack}
      showFooterAdditionalInfo
    >
      <FlowAddPaymentMethod
        basePath={PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYMENT_METHOD}
        onBack={() => {
          history.push(backPath);
        }}
        onNext={() => {
          history.push(backPath);
        }}
      />
    </Layout>
  );
};
